import React from 'react';
import { Link } from 'react-router-dom';
import Div from '../../common/components/div';
import SubHeading from '../../common/components/sub.heading.section';
import TranslatedSpan from '../../common/components/translated.span';
import { trackLinkClick } from '../../common/analytics';
import the from '../../common/objects/the';

export default function CreateAccountLinkSection() {
   return <>
      <Div isRow={true}>
         <Div
            cols={12} colsSM={12} colsMD={10} colsLG={9} colsXL={8}>
            <SubHeading style={{fontSize: 14, fontWeight: 400}}>
               <TranslatedSpan english={'No account? Get a more personalized experience'}/>{` - `}
            </SubHeading>
            <Link style={{
               color: the.color.tarheelBlue,
               fontSize: 14
            }}
               to="/create-account"
               onClick={trackLinkClick}
            >
               <TranslatedSpan english={'create an account now.'}/>
            </Link>
         </Div>
      </Div>
   </>
}